import { isPlatformBrowser, Location } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { RoutersMenu, TabRouter } from '../models/components-general/router.model';
import { HomeMenus, MenuRuter } from '../models/home-model/home.model';

@Injectable({
  providedIn: 'root',
})
export class RouteService {
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  public URL_API = environment.apiURLNew;

  // Tabs
  public tabRouter: TabRouter[] = [];

  // Menu Carvers
  public menuCarvesrt: HomeMenus[] = [
    {
      icon: 'settings',
      description: 'menus.configuration',
      isTab: false,
      menu: this.tabRouter.map((item) => ({
        description: item.descripcion,
        url: item.url ?? '',
      })),
    },
  ];

  constructor(
    private router: Router,
    private location: Location,
  ) {}

  public goToUrl(
    route: string[],
    queryParams: { [key: string]: string | number },
    newParas?: boolean,
  ): void {
    void this.navigate(route, queryParams, newParas);
  }

  public goToUrlSilent(
    route: string[],
    queryParams: { [key: string]: string | number },
    newParas?: boolean,
  ): void {
    void this.updateUrl(route, queryParams, newParas);
  }

  private async navigate(
    route: string[],
    queryParams: { [key: string]: string | number },
    newParas?: boolean,
  ): Promise<void> {
    if (this.isBrowser) {
      window.scrollTo({ top: 0 });
    }

    await (newParas
      ? this.router.navigate(route, {
          queryParams,
        })
      : this.router.navigate(route, {
          queryParams,
          queryParamsHandling: 'merge',
        }));
  }

  private async updateUrl(
    route: string[],
    queryParams: { [key: string]: string | number },
    newParas?: boolean,
  ): Promise<void> {
    if (this.isBrowser) {
      window.scrollTo({ top: 0 });
    }

    const urlTree = this.router.createUrlTree(route, {
      queryParams,
      queryParamsHandling: newParas ? null : 'merge',
    });
    const url = this.router.serializeUrl(urlTree);
    this.location.go(url);
  }

  public changeSelected(url: string, indexSelected: number): void {
    this.goToUrl([url], { indexSelected }, false);
  }
}
